<template>
    <div>
        <AccountBanner />
        <b-container>
            <b-row>
                <b-col md cols lg="4">
                    <SiteControls />
                    <PlanList />
                    <ServerList />
                </b-col>
                <b-col md><UserList /></b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import AccountBanner from '@/components/auth/accountbanner.vue'
    import SiteControls from '@/components/admin/sitecontrols.vue'
    import UserList from '@/components/admin/users/list.vue'
    import PlanList from '@/components/admin/plans/list.vue'
    import ServerList from '@/components/admin/servers/list.vue'

    export default {
        components: {
            AccountBanner,
            SiteControls,
            UserList,
            PlanList,
            ServerList
        }
    }
</script>

<style scoped>
</style>